import { Box, FormControl, InputLabel, MenuItem, Select, SxProps, Theme, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { ISurveyQuestionGroupItem } from '../../../../shared/services/survey/survey.model';
import { isNumericGroupItem, numericGroupItemError } from '../../../../shared/utils/survey-rules/question-eligibility';

interface Props {
  value: string;
  /** Fires only for questions eligible for calculations; ineligible ones explain why in a tooltip. */
  onChange: (questionId: string, item: ISurveyQuestionGroupItem | undefined) => void;
  groupItems: ISurveyQuestionGroupItem[];
  label?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

/** Question picker for calculations: eligible questions first, ineligible ones greyed with the reason. */
export const CalcQuestionSelect = ({ value, onChange, groupItems, label = 'Question', disabled = false, sx }: Props) => (
  <FormControl size='small' sx={sx ?? { flex: 1, minWidth: 200 }} disabled={disabled}>
    <InputLabel>{label}</InputLabel>
    <Select
      label={label}
      value={value}
      onChange={e => {
        const item = groupItems.find(i => i.surveyQuestionId === e.target.value);
        if (item && !isNumericGroupItem(item)) return;
        onChange(e.target.value, item);
      }}
    >
      {[...groupItems]
        .sort((a, b) => (numericGroupItemError(a) !== null ? 1 : 0) - (numericGroupItemError(b) !== null ? 1 : 0))
        .map(item => {
          const err = numericGroupItemError(item);
          return (
            <MenuItem key={item.surveyQuestionId} value={item.surveyQuestionId} sx={err ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: '100%' }}>
                <span style={{ flex: 1 }}>{item.surveyQuestion?.prompt ?? item.surveyQuestionId}</span>
                {err && (
                  <Tooltip title={err}>
                    <InfoOutlined fontSize='small' sx={{ color: 'text.secondary', flexShrink: 0 }} />
                  </Tooltip>
                )}
              </Box>
            </MenuItem>
          );
        })}
    </Select>
  </FormControl>
);
